const SLOW_EFFECTIVE_TYPES = new Set(['slow-2g', '2g']);
function hasKey(value, key) {
  return typeof value === 'object' && value !== null && key in value;
}
function readNetworkInformation() {
  if (typeof navigator === 'undefined') return undefined;
  if (!hasKey(navigator, 'connection')) return undefined;
  const {
    connection
  } = navigator;
  if (typeof connection !== 'object' || connection === null) return undefined;
  const info = {};
  if (hasKey(connection, 'saveData') && typeof connection.saveData === 'boolean') {
    info.saveData = connection.saveData;
  }
  if (hasKey(connection, 'effectiveType') && typeof connection.effectiveType === 'string') {
    info.effectiveType = connection.effectiveType;
  }
  return info;
}
export function shouldSkipSpeculativePrefetch(connection = readNetworkInformation()) {
  if (!connection) return false;
  if (connection.saveData === true) return true;
  return connection.effectiveType !== undefined && SLOW_EFFECTIVE_TYPES.has(connection.effectiveType);
}